import _ from 'underscore';
//import $ from 'jquery';

export default class OfferCampaignMassSendDialog {
  constructor($scope, $rootScope, $q, OfferCampaignService) {
    $scope.$on('show_mass_send_dialog', function(event, data) {
      window.openFancyboxDialog('div#offer_campaign_mass_send_dialog');
      $scope.campaigns = data.campaigns;
      $scope.proc_campaigns = [];
      $scope.created_times = data.created_times;
      $scope.times = [];
      mass_send_campaigns();
    });

    $scope.steps = [
      {
        id: 1,
        title: 'Campaigns - Special',
        counter: 0
      },
      {
        id: 2,
        title: 'Send Special Recipients',
        counter: 0
      },
      {
        id: 3,
        title: 'Campaigns - General',
        counter: 0
      },
      {
        id: 4,
        title: 'Send General Recipients',
        counter: 0
      },
    ];

    function get_special_ready_to_send(recipients) {
      var filtered_recipients = [];
      _.each(recipients, function(recipient) {
        var has_xls = recipient.attachments && recipient.attachments.stocklist_xls;
        var has_pi_xls = recipient.attachments && recipient.attachments.stocklist_pi_xls;
        //var ignored_xls = recipient.attachments && recipient.attachments.ignore_xls;
        var ignored_pi_xls = recipient.attachments && recipient.attachments.ignore_pi_xls;
        var is_pi = recipient.user_data.is_pi;
        var has_template = !recipient.template_pending;
        var is_pi_ready = !is_pi || has_pi_xls || ignored_pi_xls;

        if ((has_xls || has_pi_xls) && has_template && is_pi_ready)
          filtered_recipients.push(recipient);
      });

      return filtered_recipients;
    }

    function get_general_ready_to_send(recipients) {
      var filtered_recipients = [];
      _.each(recipients, function(recipient) {
        var has_xls = recipient.attachments && recipient.attachments.stocklist_xls;
        if (has_xls)
          filtered_recipients.push(recipient);
      });

      return filtered_recipients;
    }

    function send_recipients(campaign_id, recipients, is_special) {
      return recipients.reduce(function(promise, recipient, index) {
        return promise.then(function() {
          var step_id = is_special ? 1 : 3;
          $scope.steps[step_id].progress = Math.ceil(((index + 1) / recipients.length) * 100);

          if ($scope.steps[step_id].counter == 0) {
            $scope.steps[step_id].counter = 1;
            return OfferCampaignService.send_email_and_test(campaign_id, recipient.id, true, 'p.tsolpagas@epsilon-paper.com');
          }
          $scope.steps[step_id].counter = $scope.steps[step_id].counter + 1;
          return OfferCampaignService.send_email(campaign_id, recipient.id, false, null);
        });
      }, $q.when(true));
    }

    function process_campaign(campaign_id, index, is_special, deferred) {
      var t0 = performance.now();
      $scope.steps[is_special ? 0 : 2].progress = Math.ceil(((index + 1) / $scope.campaigns.length) * 100);
      $scope.steps[is_special ? 1 : 3].progress = 0;

      OfferCampaignService.get_recipients(campaign_id, is_special ? 1 : 0, 1)
        .then(function(response) {
          var recipients = null;
          if (is_special)
            recipients = get_special_ready_to_send(response.data.recipients);
          else
            recipients = get_general_ready_to_send(response.data.recipients);
          return send_recipients(campaign_id, recipients, is_special);
        })
        .then(function() {
          var t1 = performance.now();
          $scope.times.push((t1 - t0)/1000);

          deferred.resolve();
        });
    }

    function process_campaigns(is_special) {
      $scope.times = [];
      return $scope.campaigns.reduce(function(promise, campaign, index) {
        return promise.then(function() {
          var deferred = $q.defer();
          process_campaign(campaign.id, index, is_special, deferred);
          if (is_special){
            $scope.proc_campaigns.push(campaign.id);
          }
          return deferred.promise;
        });
      }, $q.when()).then(function() {

      });
    }

    function mass_send_campaigns() {
      _.each($scope.steps, function(step) {
        step.progress = 0;
        step.progress_started = true;
      });

      process_campaigns(true)
        .then(function() {
          return process_campaigns(false);
        })
        .then(function() {
          OfferCampaignService.send_campaigns_sent_email($scope.proc_campaigns, $scope.times, $scope.created_times);
          
          $rootScope.$broadcast('show_mass_send_report', { 
            campaigns: $scope.proc_campaigns,
            sent_times: $scope.times,
            created_times: $scope.created_times
          });
        });
    }
  }
}

OfferCampaignMassSendDialog.$inject = ['$scope', '$rootScope', '$q', 'OfferCampaignService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-mass-send-dialog.ctrl.js